<div class="wk-insert-media">
  <header mat-dialog-header>
    <h3 class="mb-0" mat-dialog-title>
      {{ 'ADF_INSERT_MEDIA.TITLE' | translate }}
    </h3>

    <button mat-icon-button class="close-icon" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="section">
    <mat-tab-group
      [(selectedIndex)]="selectedIndex"
      class="adf-info-drawer-tabs"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab
        *ngFor="let contentBlock of contentBlocks"
        [label]="contentBlock.label | translate"
        class="adf-info-drawer-tab"
      >
        <ng-template mat-tab-label>
          <span *ngIf="contentBlock.label">{{
            contentBlock.label | translate
          }}</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <section mat-dialog-content class="d-flex">
      <div class="w-100">
        <wk-media [selectedIndex]="selectedIndex"></wk-media>
      </div>
    </section>
  </section>

  <div mat-dialog-actions class="insert-media-dialog-actions">
    <button
      type="button"
      class="wk-button wk-button-text cancel"
      (click)="closeDialog()"
    >
      {{ 'ADF_INSERT_MEDIA.CANCEL_BUTTON' | translate }}
    </button>
    <button
      type="button"
      class="wk-button insert-image"
      [disabled]="disabledInsertBtn()"
      (click)="insertImage()"
    >
      {{ 'ADF_INSERT_MEDIA.INSERT_BUTTON' | translate }}
    </button>
  </div>
</div>
